export default function Product(props) {
    // Verificar si el producto ya está en el carrito
    const isInCart = props.cart.some(item => item.category === props.category && item.name === props.name);

    function addToCart() {
        if (isInCart) {
            // Si el producto ya está en el carrito, aumentar la cantidad
            props.setCart(prev => 
                prev.map(item => 
                    item.category === props.category && item.name === props.name 
                        ? { ...item,
                            quantity: item.quantity + 1,
                            total: (parseInt(item.total) + parseInt(props.price)).toFixed(2)
                        }
                        : item
                )
            );
        } else {
            // Si no está en el carrito, agregarlo
            props.setCart(prev => [
                ...prev,
                {
                    image: props.image,
                    category: props.category,
                    name: props.name,
                    quantity: 1,
                    price: props.price,
                    total: props.price,
                    isOnCart: true
                }
            ]);
        }
    }

    function reduceToCart() {
        props.setCart(prev => 
            prev
                .map(item => 
                    item.category === props.category && item.name === props.name 
                        ? { ...item,
                            quantity: item.quantity - 1,
                            total: item.total - props.price
                        }
                        : item
                )
                .filter(item => item.quantity > 0)  // Elimina los productos cuya cantidad es 0
        );
    }

    // Calcular la cantidad de productos en el carrito
    const productInCart = props.cart.find(item => item.category === props.category && item.name === props.name);
    const quantity = productInCart ? productInCart.quantity : 0;

    return (
        <div className="card-product">
            <img className={isInCart ? 'card-product-img in-cart' : 'card-product-img'} src={props.windowWidth <= 768 ? props.image.mobile : props.image.desktop} alt={props.category} />
            <div className="container-button">
                {isInCart ?
                    <button
                        className={isInCart ? 'in-cart' : ''}  // Cambiar el estilo si el producto está en el carrito
                    >
                        <img className="add-to-cart-img" src="/images/icon-add-to-cart.svg" alt="icono agregar al carrito" />

                        {isInCart ? 
                        
                        <div className="btn-add-to-cart-content">
                            <img onClick={reduceToCart} className="decrement" src="/images/icon-decrement-quantity.svg" alt="decrement quantity" />
                            {quantity}
                            <img onClick={addToCart} className="increment" src="/images/icon-increment-quantity.svg" alt="decrement quantity" />
                        </div>
                        
                        : 'Add to Cart'}
                    </button>
                :
                    <button
                        onClick={addToCart}
                        className={isInCart ? 'in-cart' : ''}  // Cambiar el estilo si el producto está en el carrito
                    >
                        <img className="add-to-cart-img" src="/images/icon-add-to-cart.svg" alt="icono agregar al carrito" /> Add to Cart
                    </button>
                }
            </div>
            <div className="card-description">
                <p>{props.category}</p>
                <h3>{props.name}</h3>
                <h3><span>${props.price}</span></h3>
            </div>
        </div>
    );
}
